import type { Styles } from '@adornis/ass/style.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { XImage } from '@adornis/file-utils/client/x-image.js';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement cr-image
 */
@customElement('cr-image')
export class ChromiumImage extends XImage {
  @property({ attribute: 'chancen-corners', type: Boolean }) chancenCorners: Maybe<boolean>;

  override styles(): Styles[] {
    return [
      ...super.styles(),

      {
        '#img': {
          borderRadius: this.chancenCorners ? '0 30px 0 30px' : '',
        },
      },
    ];
  }
}
